import { IconPlus } from './UEShared';

type FaqItem = { q: string; a: string };

const FAQ_ITEMS: FaqItem[] = [
  {
    q: 'How is this different from a regular Flink rider role?',
    a: 'You sign a Flink employment contract, but you deliver exclusively to Uber Eats customers rather than Flink hub orders.',
  },
  {
    q: 'Is this freelance or self-employed?',
    a: "Neither. You're a Flink employee with a genuine employment contract, which includes built-up holiday hours (8%), holiday allowance, and sick pay.",
  },
  {
    q: 'What documents do I need to apply?',
    a: 'Most important: A Dutch BSN (citizen service number), a valid ID, passport, or resident permit, and the right to work in the Netherlands.',
  },
  {
    q: 'What languages do I need to speak?',
    a: 'English is fine — both the application and the onboarding are available in English. Dutch is a nice-to-have, not a requirement.',
  },
  {
    q: 'What vehicle do I need?',
    a: "Your own bike, e-bike, or scooter. The role isn't available for cars or e-steps. Vehicle costs and maintenance are your responsibility — that's why the km bonus exists.",
  },
  {
    q: 'What equipment does Flink provide?',
    a: 'A thermal delivery bag, an Uber gear, and a phone holder for your bike. You bring the vehicle and the phone with the Uber Eats - Driver app installed.',
  },
  {
    q: 'How does the km bonus work exactly?',
    a: "€0.19 gross per km on a bike shift, €0.24/km on a scooter shift, for every kilometre you cover while clocked in. Riders typically cover around 7 km per hour. Over a 30-hour week, that's ~€40 extra on the bike or ~€50 on a scooter every week.",
  },
  {
    q: 'When and how often do I get paid?',
    a: 'Weekly, via standard Dutch payroll, into your bank account. Tips are processed separately and arrive on the same cadence.',
  },
  {
    q: 'Can I work alongside another job?',
    a: "Yes. You'll need to declare any other employment, but combining this with studies or another part-time job is common.",
  },
  {
    q: 'Minimum hours per week?',
    a: 'Most riders work between 12 and 38 hours per week, and you book the actual shifts in the Uber Eats scheduling system.',
  },
  {
    q: 'Is this role available outside Amsterdam, Groningen and Rotterdam?',
    a: "Right now, the partnership is exclusive to Amsterdam, Groningen and Rotterdam. We'll update this page if it expands.",
  },
];

const UEFaqSection = () => (
  <section id="faq">
    <div className="section-inner">
      <div className="section-head">
        <span className="section-label">
          <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3" />
            <path d="M12 17h.01" />
          </svg>
          FAQs
        </span>
        <h2 className="section-title">The questions everyone asks.</h2>
      </div>

      <div className="faq-list">
        {FAQ_ITEMS.map(({ q, a }) => (
          <details key={q}>
            <summary>
              {q}
              <span className="plus">
                <IconPlus />
              </span>
            </summary>
            <p className="faq-answer">{a}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);

export default UEFaqSection;
